<template>
  <div class="home">
    <!-- 产品特点 -->
    <section class="features">
      <div class="container">
        <h2 class="section-title">我们的优势</h2>
        <div class="features-grid">
          <div class="feature-item" v-for="(feature, index) in features" :key="index">
            <i :class="feature.icon"></i>
            <h3>{{ feature.title }}</h3>
            <p>{{ feature.desc }}</p>
          </div>
        </div>
      </div>
    </section>

    <!-- 成功案例 -->
<!--    <section class="cases">-->
<!--      <div class="container">-->
<!--        <h2 class="section-title">成功案例</h2>-->
<!--        <div class="cases-grid">-->
<!--          <div class="case-item" v-for="(caseItem, index) in cases" :key="index">-->
<!--            <img :src="caseItem.image" :alt="caseItem.title">-->
<!--            <h3>{{ caseItem.title }}</h3>-->
<!--            <p>{{ caseItem.desc }}</p>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </section>-->

    <!-- 联系我们 -->
<!--    <section class="contact">-->
<!--      <div class="container">-->
<!--        <h2 class="section-title">联系我们</h2>-->
<!--        <div class="contact-content">-->
<!--          <form class="contact-form">-->
<!--            <input type="text" placeholder="您的姓名" v-model="form.name">-->
<!--            <input type="tel" placeholder="联系电话" v-model="form.phone">-->
<!--            <textarea placeholder="您的需求" v-model="form.message"></textarea>-->
<!--            <button type="submit" @click.prevent="submitForm">提交</button>-->
<!--          </form>-->
<!--          <div class="contact-info">-->
<!--            <p><i class="icon-phone"></i> 400-123-4567</p>-->
<!--            <p><i class="icon-email"></i> contact@example.com</p>-->
<!--            <p><i class="icon-address"></i> 某某市某某区某某路123号</p>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </section>-->
  </div>
</template>

<script>

export default {
  name: 'Home',

  data() {
    return {
      features: [
        { icon: 'icon-quality', title: '品质保证', desc: '严格的质量控制体系' },
        { icon: 'icon-service', title: '优质服务', desc: '7×24小时客户服务' },
        { icon: 'icon-tech', title: '技术领先', desc: '行业领先的技术团队' },
        { icon: 'icon-price', title: '价格优势', desc: '高性价比的产品方案' }
      ],
      cases: [
        { image: require('@/assets/logo.png'), title: '某某集团项目', desc: '为客户提供全方位解决方案' },
        { image: require('@/assets/logo.png'), title: '某某政府项目', desc: '高效稳定的系统部署' },
        { image: require('@/assets/logo.png'), title: '某某教育项目', desc: '创新的教育行业解决方案' }
      ],
      form: {
        name: '',
        phone: '',
        message: ''
      }
    }
  },
  methods: {
    submitForm() {
      // 表单提交逻辑
      console.log('表单提交:', this.form)
      // 这里可以添加表单验证和AJAX提交
    }
  }
}
</script>

<style scoped>
.home {
  padding-top: 200px; /* 给固定导航栏留出空间 */
}

.section-title {
  text-align: center;
  margin-bottom: 40px;
  font-size: 32px;
  color: #333;
}

.features-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 30px;
}

.feature-item {
  text-align: center;
  padding: 30px 20px;
  border-radius: 5px;
  background: #f9f9f9;
  transition: all 0.3s;
}

.feature-item:hover {
  transform: translateY(-5px);
  box-shadow: 0 5px 15px rgba(0,0,0,0.1);
}

.feature-item i {
  font-size: 40px;
  color: #42b983;
  margin-bottom: 20px;
}

.cases-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
}

.case-item {
  border: 1px solid #eee;
  border-radius: 5px;
  overflow: hidden;
}

.case-item img {
  width: 100%;
  height: 200px;
  object-fit: cover;
}

.case-item h3 {
  padding: 15px;
  font-size: 18px;
}

.case-item p {
  padding: 0 15px 15px;
  color: #666;
}

.contact-content {
  display: flex;
  justify-content: space-between;
}

.contact-form {
  flex: 1;
  max-width: 500px;
}

.contact-form input,
.contact-form textarea {
  width: 100%;
  padding: 10px;
  margin-bottom: 15px;
  border: 1px solid #ddd;
  border-radius: 4px;
}

.contact-form textarea {
  height: 120px;
}

.contact-form button {
  background: #42b983;
  color: white;
  border: none;
  padding: 12px 30px;
  border-radius: 4px;
  cursor: pointer;
}

.contact-info {
  flex: 1;
  max-width: 400px;
  padding-left: 50px;
}

.contact-info p {
  margin-bottom: 15px;
  display: flex;
  align-items: center;
}

.contact-info i {
  margin-right: 10px;
  font-size: 20px;
  color: #42b983;
}

@media (max-width: 992px) {
  .features-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .cases-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .contact-content {
    flex-direction: column;
  }

  .contact-info {
    padding-left: 0;
    margin-top: 30px;
  }
}

@media (max-width: 576px) {
  .features-grid {
    grid-template-columns: 1fr;
  }

  .cases-grid {
    grid-template-columns: 1fr;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Home.vue